import React, { useState, useEffect, useRef, Fragment } from "react";
import BreadCrumb from "../../components/Cards/BreadCrumb";
import Header from "../../components/Sidebar/Header";
import Sidebar from "../../components/Sidebar/Sidebar";
import { useLocation } from "react-router-dom";
import orders from "../../icons/reports.svg";
import addIcon from "../../icons/add.svg";
import InfoCard from "../../components/Cards/Carts";
import Spiner from "../../components/Loader/Spiner";
import { Menu, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
// import Add from "./Add";
// import Edit from "./Edit";
// import View from "./View";
import axios from "axios";
// Icons
import Cookies from "js-cookie";

// redux mapping
import { useDispatch, useSelector } from "react-redux";
import {
  getMainReport,
  filteredItem,
  removeFilter,
  filterDate,
} from "../../../features/Global/MostSellingByCategorise";
// Grid
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";
import { ChartPieIcon } from "@heroicons/react/24/outline";

const Index = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.MostSellingByCategories.copyData);
  const loader = useSelector((state) => state.MostSellingByCategories.loading);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }
  // hook to fetch items
  useEffect(() => {
    dispatch(getMainReport());
  }, []);
  const [pageSize, setPageSize] = useState(10);
  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarExport />
      </GridToolbarContainer>
    );
  }

  const search = useRef();
  // ------------------------------------ Filters ------------------------------------ //
  const handleSearch = (e) => {
    search.current.value = e;

    dispatch(filteredItem(search.current.value));
  };
  const handleRemoveFilters = () => {
    dispatch(removeFilter());
    search.current.value = "";
    setFrom("");
    setTo("");
  };
  useEffect(() => {
    dispatch(getMainReport());
  }, []);
  useEffect(() => {
    if (from !== "" && to !== "") {
      dispatch(filterDate([from, to]));
    }
  }, [from, to]);
  const handleCheckOfferTypes = (value) => {
    if (value === 0) {
      return "No Offer";
    }
    if (value === 1) {
      return "Buy one get one";
    }
    if (value === 2) {
      return "Percentage discount";
    }
    // else {
    //   return "Buy one get some percenteage of";
    // }
  };
  const now = new Date();

  const handleSelectedFilter = (f, t) => {
    setFrom(f);
    setTo(t);
  };
  const columns = [
    { field: "id", headerName: "Id", minWidth: 150, flex: 1 },
    { field: "category", headerName: "Category", minWidth: 150, flex: 1 },
    // {
    //   field: "imageUrl",
    //   headerName: "Image",
    //   width: 70,
    //   renderCell: (cellvalues) => {
    //     return (
    //       <img
    //         onClick={() => {
    //           // handleUload(cellvalues.row.id);
    //         }}
    //         className="w-10 h-10 rounded-full"
    //         src={cellvalues.value}
    //       />
    //     );
    //   },
    // },
    {
      field: "name",
      headerName: "name",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "price",
      headerName: "price",
      minWidth: 200,
      flex: 1,
      renderCell: (params) => (
        <p className="mx-auto text-right">
          {Intl.NumberFormat().format(params.value)} IQD
        </p>
      ),
    },
    {
      field: "brand",
      headerName: "Brand",
      minWidth: 150,
      flex: 1,
    },
    {
      field: "subCategory",
      headerName: "Sub Category",
      minWidth: 150,
      flex: 1,
    },
    {
      field: "qty",
      headerName: "Quantity in stock",
      minWidth: 150,
      flex: 1,
      renderCell: (params) => (
        <p className="mx-auto text-right">{params.value}</p>
      ),
    },
    {
      field: "selledItem",
      headerName: "Quantity of sold",
      minWidth: 150,
      flex: 1,
      renderCell: (params) => (
        <p className="mx-auto text-right">{params.value}</p>
      ),
    },
    {
      field: "totalPrice",
      headerName: "Total Price",
      minWidth: 150,
      flex: 1,
      renderCell: (params) => (
        <p className="mx-auto text-right">
          {" "}
          {Intl.NumberFormat().format(params.value)} IQD
        </p>
      ),
    },
    {
      field: "totalOrdered",
      headerName: "Total Ordered",
      minWidth: 150,
      flex: 1,
      renderCell: (params) => (
        <p className="mx-auto text-right">
          {Intl.NumberFormat().format(params.value)} IQD
        </p>
      ),
    },
    {
      field: "orderDateString",
      headerName: "Date",
      minWidth: 150,
      flex: 1,
      renderCell: (params) => (
        <p className="mx-auto text-right">{params.value}</p>
      ),
    },
  ];
  // const handleDateFilter =(from, to) => {
  //   data?.filter((item) => {
  //     item?.orderDateString > from && item?.orderDateString < to;
  //   });
  // };

  return (
    <main className="relative h-screen overflow-y-auto bg-gray-100 dark:bg-gray-800 ltr">
      <div className="flex items-start justify-between h-screen overflow-y-auto">
        <Sidebar />
        <div className="flex flex-col w-full h-screen overflow-y-auto md:space-y-4">
          <header className="z-10 flex items-center justify-between w-full h-16">
            <Header />
          </header>
          <div className="h-screen px-4 pb-24 overflow-auto md:px-6 dark:bg-gray-900">
            <div className="">
              <BreadCrumb
                page={"Most selling categories"}
                icon={<ChartPieIcon className="inline w-6 mx-2" />}
              />
            </div>
            {/* <InfoCard /> */}
            <div className="my-4  h-[44rem] rounded-md bg-gray-50 dark:bg-gray-800">
              <div className="my-10  ">
                <div className="flex  w-full">
                  <div className="rounded-xl border border-gray-200 bg-white p-6 shadow-lg w-full dark:bg-gray-800 dark:border-gray-600">
                    <div className="">
                      <div className="relative mb-5 w-full flex  items-center justify-between rounded-md">
                        <svg
                          className="absolute left-2 block h-5 w-5 text-gray-400"
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <circle cx="11" cy="11" r="8" className=""></circle>
                          <line
                            x1="21"
                            y1="21"
                            x2="16.65"
                            y2="16.65"
                            className=""
                          ></line>
                        </svg>
                        <input
                          type="name"
                          name="search"
                          ref={search}
                          onChange={(e) => handleSearch(e.target.value)}
                          className="h-12 w-full cursor-text rounded-md border border-gray-100 bg-gray-100 py-4 pr-40 pl-12 shadow-sm outline-none focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 dark:bg-gray-700 dark:text-gray-700 dark:border-gray-600"
                          placeholder="Search by Name, Brand, Category, Subcategory, Price, etc"
                        />
                      </div>

                      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                        <div className="flex flex-col">
                          <label
                            htmlFor="date"
                            className="text-sm font-medium text-stone-600 dark:text-stone-300"
                          >
                            From
                          </label>
                          <input
                            type="date"
                            id="date"
                            value={from}
                            onChange={(e) => setFrom(e.target.value)}
                            className="mt-2 block w-full cursor-pointer rounded-md border border-gray-100 bg-gray-100 px-2 py-2 shadow-sm outline-none focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-300"
                          />
                        </div>
                        <div className="flex flex-col">
                          <label
                            htmlFor="date"
                            className="text-sm font-medium text-stone-600 dark:text-stone-300"
                          >
                            To
                          </label>
                          <input
                            type="date"
                            id="date"
                            value={to}
                            onChange={(e) => setTo(e.target.value)}
                            className="mt-2 block w-full cursor-pointer rounded-md border border-gray-100 bg-gray-100 px-2 py-2 shadow-sm outline-none focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-300"
                          />
                        </div>

                        {/* <div className="flex flex-col">
                          <label
                            htmlFor="status"
                            className="text-sm font-medium text-stone-600"
                          >
                            Status
                          </label>

                          <select
                            id="status"
                            className="mt-2 block w-full cursor-pointer rounded-md border border-gray-100 bg-gray-100 px-2 py-2 shadow-sm outline-none focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
                          >
                            <option>Dispached Out</option>
                            <option>In Warehouse</option>
                            <option>Being Brought In</option>
                          </select>
                        </div> */}
                        <div className="mt-6 grid w-full grid-cols-2  space-x-4 md:flex float-right right-0">
                          {/* <button className="rounded-lg bg-blue-600 px-8 py-2 font-medium text-white outline-none hover:opacity-80 focus:ring">
                          Search
                        </button> */}
                          <Menu
                            as="div"
                            className="relative inline-block h-full py-1 my-auto text-left align-middle "
                          >
                            <div>
                              <Menu.Button className="inline-flex justify-center w-full px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2 focus:ring-offset-gray-100 dark:focus-ring-offset-gray-600 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-600">
                                Filters
                                <ChevronDownIcon
                                  className="w-5 h-5 ml-2 -mr-1"
                                  aria-hidden="true"
                                />
                              </Menu.Button>
                            </div>

                            <Transition
                              as={Fragment}
                              enter="transition ease-out duration-100"
                              enterFrom="transform opacity-0 scale-95"
                              enterTo="transform opacity-100 scale-100"
                              leave="transition ease-in duration-75"
                              leaveFrom="transform opacity-100 scale-100"
                              leaveTo="transform opacity-0 scale-95"
                            >
                              <Menu.Items className="absolute right-0 z-10 w-56 mt-2 origin-top-right bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none dark:bg-gray-700 dark:text-gray-300">
                                <div className="py-1">
                                  <Menu.Item>
                                    {({ active }) => (
                                      <button
                                        onClick={() =>
                                          handleSelectedFilter(
                                            new Date(
                                              now.getFullYear(),
                                              now.getMonth(),
                                              now.getDate() - 7
                                            )
                                              .toISOString()
                                              .split("T")[0],
                                            new Date(
                                              now.getFullYear(),
                                              now.getMonth(),
                                              now.getDate()
                                            )
                                              .toISOString()
                                              .split("T")[0]
                                          )
                                        }
                                        className={classNames(
                                          active
                                            ? "bg-gray-100 text-gray-900 dark:bg-gray-600 dark:text-gray-200"
                                            : "text-gray-700 dark:text-gray-300",
                                          "block px-4 py-2 text-sm w-full text-left"
                                        )}
                                      >
                                        Last week{" "}
                                      </button>
                                    )}
                                  </Menu.Item>
                                  <Menu.Item>
                                    {({ active }) => (
                                      <button
                                        onClick={() =>
                                          handleSelectedFilter(
                                            new Date(
                                              now.getFullYear(),
                                              now.getMonth() - 1,
                                              now.getDate()
                                            )
                                              .toISOString()
                                              .split("T")[0],
                                            new Date(
                                              now.getFullYear(),
                                              now.getMonth(),
                                              now.getDate()
                                            )
                                              .toISOString()
                                              .split("T")[0]
                                          )
                                        }
                                        className={classNames(
                                          active
                                            ? "bg-gray-100 text-gray-900 dark:bg-gray-600 dark:text-gray-200"
                                            : "text-gray-700 dark:text-gray-300",
                                          "block px-4 py-2 text-sm w-full text-left"
                                        )}
                                      >
                                        Last month{" "}
                                      </button>
                                    )}
                                  </Menu.Item>
                                  <Menu.Item>
                                    {({ active }) => (
                                      <button
                                        onClick={() =>
                                          handleSelectedFilter(
                                            new Date(
                                              now.getFullYear(),
                                              now.getMonth() - 3,
                                              now.getDate()
                                            )
                                              .toISOString()
                                              .split("T")[0],
                                            new Date(
                                              now.getFullYear(),
                                              now.getMonth(),
                                              now.getDate()
                                            )
                                              .toISOString()
                                              .split("T")[0]
                                          )
                                        }
                                        className={classNames(
                                          active
                                            ? "bg-gray-100 text-gray-900 dark:bg-gray-600 dark:text-gray-200"
                                            : "text-gray-700 dark:text-gray-300",
                                          "block px-4 py-2 text-sm w-full text-left"
                                        )}
                                      >
                                        Last three month
                                      </button>
                                    )}
                                  </Menu.Item>
                                  <Menu.Item>
                                    {({ active }) => (
                                      <button
                                        onClick={() =>
                                          handleSelectedFilter(
                                            new Date(
                                              now.getFullYear() - 1,
                                              now.getMonth(),
                                              now.getDate()
                                            )
                                              .toISOString()
                                              .split("T")[0],
                                            new Date(
                                              now.getFullYear(),
                                              now.getMonth(),
                                              now.getDate()
                                            )
                                              .toISOString()
                                              .split("T")[0]
                                          )
                                        }
                                        className={classNames(
                                          active
                                            ? "bg-gray-100 text-gray-900 dark:bg-gray-600 dark:text-gray-200"
                                            : "text-gray-700 dark:text-gray-300",
                                          "block px-4 py-2 text-sm w-full text-left"
                                        )}
                                      >
                                        Last three month
                                      </button>
                                    )}
                                  </Menu.Item>
                                </div>
                              </Menu.Items>
                            </Transition>
                          </Menu>
                          <button
                            className="active:scale-95 rounded-lg bg-gray-200 px-8 py-2 font-medium text-gray-600 outline-none focus:ring hover:opacity-90 dark:bg-gray-700 dark:text-gray-300"
                            onClick={() => handleRemoveFilters()}
                          >
                            Reset
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* {loader && <Spiner />} */}
              {loader ? (
                <>
                  <Spiner />
                </>
              ) : (
                <div className="flex items-center w-auto h-full mx-2 mt-2 dark:bg-gray-800">
                  {/* <DataGrid rows={data[0]} columns={columns} className="dark:bg-gray-800 dark:text-gray-200" /> */}
                  <DataGrid
                    rows={data}
                    columns={columns}
                    // getRowId={(row) => row.categoryId}
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    rowsPerPageOptions={[10, 20, 50, 100]}
                    className="min-h-full dark:text-gray-200 "
                    components={{
                      Toolbar: CustomToolbar,
                    }}
                    // checkboxSelection
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Index;
